// extracted by mini-css-extract-plugin
export default {"root":"Stage-module_root__RGyw_"};